import { render, staticRenderFns } from "./ClaimsBucket.3.vue?vue&type=template&id=ff43b5aa&"
import script from "./ClaimsBucket.3.vue?vue&type=script&lang=js&"
export * from "./ClaimsBucket.3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports